module.exports = __webpack_public_path__ + "static/media/banner1.930fa869.jpg";